const UC = {
  data: () => ({}),
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    }
  },
  mounted() {},
  methods: {
    SaveUtilizadorColheita() {
      if (typeof this.getSession.Colheita == "undefined") return

      if (this.getSession.Colheita.hasOwnProperty("uc")) {
        var object = Object.assign({}, this.getSession.Colheita.uc)
        object.id = object[`id_${this.Store}`]
        delete object[`id_${this.Store}`]

        this.$store
          .dispatch(`${this.Store}/update`, object)
          .then(res => {
            if (res) this.$toast.success(this.$success)
            else this.$toast.error(this.$error)

            this.$store.dispatch(
              "utilizador_colheita/get",
              this.getSession.Colheita.id_colheita
            )

            setTimeout(() => {
              delete this.getSession.Colheita.uc
            }, 110)
          })
          .catch(err => {
            this.$toast.error(this.$error)
          })
      } else {
        var object = Object.assign({}, this.MyObject)
        object.id_colheita = this.getSession.Colheita.id_colheita
        object.estado = Number(object.estado)
        this.$store
          .dispatch(`${this.Store}/insert`, object)
          .then(res => {
            if (res) this.$toast.success(this.$success)
            else this.$toast.error(this.$error)

            this.$store.dispatch(
              "utilizador_colheita/get",
              this.getSession.Colheita.id_colheita
            )
            this.$eventBus.$emit("AddDialog", false)
          })
          .catch(err => {
            this.$toast.error(this.$error)
            this.$eventBus.$emit("AddDialog", false)
          })
      }
    },
    DeleteUtilizadorColheita() {
      if (!this.getSession.Colheita.hasOwnProperty("uc")) return

      this.$store
        .dispatch(`${this.Store}/delete`, {
          id: this.getSession.Colheita.uc[`id_${this.Store}`]
        })
        .then(res => {
          if (res) this.$toast.success(this.$success)
          else this.$toast.error(this.$error)

          this.$store.dispatch(
            "utilizador_colheita/get",
            this.getSession.Colheita.id_colheita
          )

          setTimeout(() => {
            delete this.getSession.Colheita.uc
          }, 110)

          this.$eventBus.$emit("DeleteDialogColheita", false)
        })
        .catch(err => {
          this.$toast.error(this.$error)

          setTimeout(() => {
            delete this.getSession.Colheita.uc
          }, 110)
          this.$eventBus.$emit("DeleteDialogColheita", false)
        })
    }
  }
}

export default UC
